import React from 'react'
import { saveAs } from 'file-saver'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import RestUtilities from '../services/Base';

interface Props {
  lotCode: any;
  coAFileName: string
  uploader:  (selectedFiles: FileList|null) => void
  uploading: boolean
  licensedProducer: string
  sku: string
  harvestDate: string
}

const CoAModalView = (props: Props) => {
  const renderUploadButton = () => {
    return (
      <div style={{ textAlign: "center", display:"inline", paddingLeft:"0" }}>
          <input onChange={(e) =>{ props.uploader(e.target.files)}} type="file" name="file2" id="file2"  accept="application/pdf"/>
          {props.uploading ? <FontAwesomeIcon icon="spinner" spin /> : <label className="hiddenInput" htmlFor="file2">
            <div style={{ padding:"7px"}} className="btn btn-orange">
            {!props.uploading && props.coAFileName && props.coAFileName.trim().length > 0 ? "Replace" :"Upload"} CoA
            </div>
          </label>}
        </div>
      )
  }

  const getCoa = async () => {
    const downloadLink = `/api/lot/${props.licensedProducer}/${props.lotCode.harvestDate}/${props.lotCode.lotCodeId.trim()}/${props.sku.trim()}/coa`;
    const response = await RestUtilities.get(downloadLink);
    saveAs(response.content, props.coAFileName.trim());
  }

  return (
    <div>
      <div className="form-row">
        <div className="col-12">
          <b>Certificate of Analysis (CoA)</b>
          {!props.uploading && props.coAFileName && props.coAFileName.trim().length > 0 && <span>&nbsp;<FontAwesomeIcon icon={faCheckCircle} color="green" /> Uploaded</span>}
        </div>
      </div>
      <div className="form-row">
        <div className="col-12" style={{ "padding": "10px 0px" }}>
          {(!props.uploading && (props.coAFileName && props.coAFileName.trim().length > 0)) &&
            <><button title={props.coAFileName} className="btn btn-orange" onClick={getCoa}>
              Download CoA
          </button>&nbsp;</>}
            {renderUploadButton()}
          </div>
      </div>
    </div>
  );
}

export default CoAModalView;
